import { Order } from '@porterin/booking-flow/src/order-history/domain/entities/OrderHistory';
import { AgreedDocs } from '@porterin/booking-flow/src/order-review/domain/entities/AgreedDocs';
import { Loadable } from '@porterin/booking-flow/src/order-review/view/types/Loadable';
import React from 'react';

export type User = {
  authToken?: string;
  mobile?: string;
  name?: string;
  requirementType?: string;
  email?: string;
  whatsappConsent?: boolean;
};

export type AuthContextType = {
  isAuthenticated: Loadable<boolean, any>;
  setIsAuthenticated: (loadable: Loadable<boolean, any>) => void;
  user?: User;
  setUser: (user?: User) => void;
  orderHistory: Loadable<Order[], any>;
  agreedDocs?: AgreedDocs;
  setAgreedDocs?: (agreed_docs?: AgreedDocs) => void;
};

export const getDefaultValue = (): AuthContextType => ({
  isAuthenticated: { state: 'Init' },
  setIsAuthenticated: _ => {},
  user: undefined,
  setUser: _user_profile => {},
  orderHistory: { state: 'Init' },
  agreedDocs: undefined,
  setAgreedDocs: undefined,
});

export const context = React.createContext<AuthContextType>(getDefaultValue());

export const useAuthContext = () => React.useContext(context);
